/**
 * Sticky Header
 *
 * @param {Object} [options]
 *
 * @returns {void}
 */
const stickyHeader = (options) => {
    const defaults = {
        offset: 0,
        header: '.js-header',
        space: '.js-header-space',
        activeClass: 'is-sticky',
        adminBar: '#wpadminbar',
    };

    const settings = $.extend({}, defaults, options);

    const w = $(window);
    const space = $(settings.space);
    const header = $(settings.header);
    const headerHeight = header.outerHeight();
    const position = header.css('position');

    let height = position === 'absolute' ? 0 : headerHeight;
    let offsetTop = $(settings.adminBar).outerHeight();

    let scrollTop = w.scrollTop(), hasClass = false;

    if (w.outerWidth() <= 600) {
        settings.offset = offsetTop;
        offsetTop = 0;
    }

    if (scrollTop > settings.offset && !hasClass) {
        header.addClass(settings.activeClass).css('top', offsetTop);
        space.css('height', height);
        hasClass = true;
    }

    w.on('scroll', function () {
        scrollTop = $(this).scrollTop();
        hasClass = header.hasClass(settings.activeClass);

        if (scrollTop > settings.offset && !hasClass) {
            header.addClass(settings.activeClass).css('top', offsetTop);
            space.css('height', height);
            hasClass = true;
        }

        if (scrollTop <= settings.offset + 1 && hasClass) {
            header.removeClass(settings.activeClass).css('top', 0);
            space.css('height', 0);
            hasClass = false;
        }
    });
};

export default stickyHeader;
